// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__1pEV1","bookingInfo":"BookingTimeInfo_bookingInfo__1l3C1","dateSection":"BookingTimeInfo_dateSection__1KLrG"};